import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054c6549"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Tabel Invoices"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Data semua kegiatan finance di PT TKI")
  ])
], -1))
const _hoisted_3 = { class: "resume-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 col-lg-3 px-3",
  style: {"font-size":"larger","font-weight":"500","margin-top":"5px"}
}, " Rangkuman Tabel ", -1))
const _hoisted_5 = { class: "content-wrapper col-12 col-lg-9" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  class: "d-flex flex-row border-0 pt-5 px-0 gap-2",
  style: {"margin-left":"30px"}
}
const _hoisted_10 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "d-flex flex-row border-0 pt-5 px-0",
  style: {"margin-left":"30px","margin-right":"30px"}
}
const _hoisted_13 = { class: "col-2 px-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "PAID",
  key: "PAID"
}, "Terbayar", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "UNPAID",
  key: "UNPAID"
}, "Belum Terbayar", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  key: "UNPAID"
}, "Semua", -1))
const _hoisted_18 = { class: "card-body py-3" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
  /*#__PURE__*/_createElementVNode("th"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, "Pilih"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Tagihan"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tagihan"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Tagihan"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nominal Tagihan"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
], -1))
const _hoisted_22 = { class: "fw-bolder text-muted" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_25 = { class: "min-w-125px; text-center" }
const _hoisted_26 = { class: "min-w-125px; text-center" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "text-left"
}
const _hoisted_30 = ["onClick", "value"]
const _hoisted_31 = {
  key: 1,
  class: "text-left"
}
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = {
  key: 2,
  class: "text-left"
}
const _hoisted_37 = {
  key: 3,
  class: "text-left"
}
const _hoisted_38 = { class: "text-left" }
const _hoisted_39 = { class: "text-left" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "symbol symbol-35px me-2",
  type: "button",
  "data-bs-toogle": "tooltip",
  title: "Bayar"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/icons/pay.svg",
    alt: ""
  })
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/split.svg",
  alt: ""
}, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "row mt-5 mb-5" }
const _hoisted_56 = ["validation-schema"]
const _hoisted_57 = { class: "modal-dialog modal-lg" }
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = { class: "modal-header" }
const _hoisted_60 = {
  key: 0,
  class: "modal-title justify-content-center"
}
const _hoisted_61 = {
  key: 1,
  class: "modal-title justify-content-center"
}
const _hoisted_62 = { class: "modal-body row" }
const _hoisted_63 = {
  key: 0,
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"large"}
}
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"large"}
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Nomor Virtual Account ")
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Masih Aktif", -1))
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" dan bisa dipakai: ")
const _hoisted_71 = [
  _hoisted_68,
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Nomor Virtual Account ")
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Sudah Tidak Aktif", -1))
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" dan tidak dapat digunakan: ")
const _hoisted_76 = [
  _hoisted_73,
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = {
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"large"}
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { class: "d-flex" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-25" }, " Nama VA ", -1))
const _hoisted_81 = { class: "d-flex" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-25" }, " No Virtual Account ", -1))
const _hoisted_83 = { key: 0 }
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_85 = { class: "text-primary" }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_88 = { class: "text-danger text-decoration-line-through" }
const _hoisted_89 = { class: "d-flex" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-25" }, " Bank Virtual Account ", -1))
const _hoisted_91 = { class: "d-flex" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-25" }, " Aktif Sampai ", -1))
const _hoisted_93 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-25" }, null, -1))
const _hoisted_95 = {
  class: "alert alert-danger",
  style: {"color":"red"}
}
const _hoisted_96 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-25" }, null, -1))
const _hoisted_98 = {
  key: 1,
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"large"}
}
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { key: 2 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-left bd-highlight required",
  style: {"font-size":"small"}
}, " Metode ", -1))
const _hoisted_102 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_103 = { class: "col-12" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Otomatis",
  key: "atomatis"
}, " Otomatis ", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Manual",
  key: "manual"
}, "Manual", -1))
const _hoisted_106 = {
  key: 0,
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"small"}
}
const _hoisted_107 = {
  key: 1,
  class: "p-3 col-12 text-left bd-highlight d-flex justify-content-between",
  style: {"font-size":"small"}
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Pembayaran Tanpa Sumber Dana ", -1))
const _hoisted_109 = {
  key: 0,
  class: "form-check"
}
const _hoisted_110 = { key: 2 }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"small"}
}, " Sumber Dana ", -1))
const _hoisted_112 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_113 = { class: "col-12" }
const _hoisted_114 = {
  key: 0,
  style: {"font-size":"9px","color":"green"}
}
const _hoisted_115 = { key: 1 }
const _hoisted_116 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, null, -1))
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = {
  key: 3,
  class: "fv-plugins-message-container"
}
const _hoisted_120 = { class: "fv-help-block" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-left bd-highlight required",
  style: {"font-size":"small"}
}, " Pilih Bank Pembayaran ", -1))
const _hoisted_122 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_123 = { class: "col-12" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Pilih BANK", -1))
const _hoisted_125 = ["value"]
const _hoisted_126 = { class: "col-12" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Pilih BANK", -1))
const _hoisted_128 = ["value"]
const _hoisted_129 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, null, -1))
const _hoisted_131 = [
  _hoisted_130
]
const _hoisted_132 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_133 = { class: "fv-help-block" }
const _hoisted_134 = { key: 3 }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-left bd-highlight required",
  style: {"font-size":"small"}
}, " Nomor Rekening ", -1))
const _hoisted_136 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_137 = { class: "col-12" }
const _hoisted_138 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, null, -1))
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_142 = { class: "fv-help-block" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"small"}
}, " Catatan ", -1))
const _hoisted_144 = {
  key: 3,
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"small","color":"#e50200"}
}
const _hoisted_145 = {
  key: 4,
  class: "p-3 col-12 text-left bd-highlight",
  style: {"font-size":"small","color":"#e50200"}
}
const _hoisted_146 = {
  key: 5,
  class: "p-4 col-12 text-left bd-highlight",
  style: {"font-size":"small","color":"#3268ff"}
}
const _hoisted_147 = {
  key: 6,
  class: "table-responsive"
}
const _hoisted_148 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Harga"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Pajak"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah")
  ])
], -1))
const _hoisted_150 = { class: "text-center" }
const _hoisted_151 = { class: "text-center" }
const _hoisted_152 = { class: "text-center" }
const _hoisted_153 = { class: "text-center" }
const _hoisted_154 = { class: "text-center" }
const _hoisted_155 = { class: "text-center" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1))
const _hoisted_157 = { class: "text-center" }
const _hoisted_158 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sub Total", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_166 = { class: "min-w-150px; text-center" }
const _hoisted_167 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Pajak", -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_175 = { class: "min-w-150px; text-center" }
const _hoisted_176 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Diskon", -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_184 = { class: "min-w-150px; text-center" }
const _hoisted_185 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Biaya Pengiriman ", -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_193 = { class: "min-w-150px; text-center" }
const _hoisted_194 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Total", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1))
const _hoisted_202 = { class: "min-w-150px; text-center" }
const _hoisted_203 = {
  key: 7,
  class: "row fv-row mb-6"
}
const _hoisted_204 = { class: "d-flex bd-highlight" }
const _hoisted_205 = { class: "p-2 flex-fill bd-highlight" }
const _hoisted_206 = { class: "col-lg-6 fv-row" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "No VA", -1))
const _hoisted_208 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_4"
}
const _hoisted_209 = { class: "modal-dialog modal-xl" }
const _hoisted_210 = { class: "modal-content" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row-reverse modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-bs-target": "#kt_modal_4",
    "data-bs-toggle": "modal"
  }, " X ")
], -1))
const _hoisted_212 = { class: "modal-body" }
const _hoisted_213 = ["innerHTML"]
const _hoisted_214 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-body\" data-v-054c6549><div class=\"modal-body\" data-v-054c6549></div><div class=\"modal-body\" data-v-054c6549></div><div class=\"modal-body\" data-v-054c6549></div><div class=\"modal-body\" data-v-054c6549></div><div class=\"modal-body\" data-v-054c6549></div><div class=\"modal-body\" data-v-054c6549></div></div>", 1)
const _hoisted_215 = { class: "modal-footer" }
const _hoisted_216 = { class: "row mt-5 mb-5" }
const _hoisted_217 = {
  tabindex: "-1",
  id: "kt_modal_preview",
  class: "modal fade",
  ref: "previewModal",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_218 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_219 = { class: "modal-content" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Konfirmasi Pembayaran")
], -1))
const _hoisted_221 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_222 = { class: "table-responsive" }
const _hoisted_223 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Harga"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Pajak"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah")
  ])
], -1))
const _hoisted_225 = { class: "text-left" }
const _hoisted_226 = { class: "text-left" }
const _hoisted_227 = { class: "text-left" }
const _hoisted_228 = { class: "text-left" }
const _hoisted_229 = { class: "text-left" }
const _hoisted_230 = { class: "text-left" }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, null, -1))
const _hoisted_232 = { class: "text-left" }
const _hoisted_233 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, "Sub Total", -1))
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_241 = { class: "min-w-150px; text-left" }
const _hoisted_242 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, "Pajak", -1))
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_250 = { class: "min-w-150px; text-left" }
const _hoisted_251 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, "Diskon", -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_259 = { class: "min-w-150px; text-left" }
const _hoisted_260 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, "Biaya Pengiriman", -1))
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_268 = { class: "min-w-150px; text-left" }
const _hoisted_269 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, "Total", -1))
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_277 = { class: "min-w-150px; text-left" }
const _hoisted_278 = { class: "row fv-row mb-6" }
const _hoisted_279 = { class: "d-flex bd-highlight" }
const _hoisted_280 = { class: "p-2 flex-fill bd-highlight" }
const _hoisted_281 = { class: "col-lg-6 fv-row" }
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "No VA", -1))
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-bs-dismiss": "modal"
  }, " Tutup ")
], -1))
const _hoisted_284 = { class: "row mt-5 mb-5" }
const _hoisted_285 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_286 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_manual"
}
const _hoisted_287 = {
  key: 0,
  class: "modal-dialog modal-xl"
}
const _hoisted_288 = { class: "modal-content" }
const _hoisted_289 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-054c6549><div class=\"d-flex flex-column bd-highlight mb-3\" data-v-054c6549><div class=\"p-2 bd-highlight\" data-v-054c6549><h2 class=\"fw-bolder\" data-v-054c6549>Bayar Manual</h2></div><div class=\"p-2 bd-highlight\" data-v-054c6549><span class=\"text-muted mt-1 fw-bold fs-7\" data-v-054c6549>Data semua kegiatan finance di PT TKI</span></div></div></div>", 1)
const _hoisted_290 = { class: "modal-body" }
const _hoisted_291 = { class: "table-responsive" }
const _hoisted_292 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Order"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tax")
  ])
], -1))
const _hoisted_294 = { class: "text-left" }
const _hoisted_295 = { class: "text-left" }
const _hoisted_296 = { class: "text-left" }
const _hoisted_297 = { class: "text-left" }
const _hoisted_298 = { class: "text-left" }
const _hoisted_299 = { class: "text-left" }
const _hoisted_300 = { class: "text-left" }
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_302 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_303 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-left",
  style: {"padding-left":"30px !important"}
}, " Sub Total ", -1))
const _hoisted_309 = { class: "min-w-125px; text-left" }
const _hoisted_310 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_312 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_315 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-left",
  style: {"padding-left":"30px !important"}
}, " Total Diskon ", -1))
const _hoisted_317 = { class: "min-w-125px; text-left" }
const _hoisted_318 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_322 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_324 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-left",
  style: {"padding-left":"30px !important"}
}, " Total Pajak ", -1))
const _hoisted_325 = { class: "min-w-125px; text-left" }
const _hoisted_326 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_327 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left pb-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-lg-6 col-form-label fw-bold fs-6" }, "Terbilang")
], -1))
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_330 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_331 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_332 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-left",
  style: {"padding-left":"30px !important"}
}, " Biaya Pengiriman ", -1))
const _hoisted_333 = { class: "min-w-125px; text-left" }
const _hoisted_334 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_335 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_336 = {
  colspan: "3",
  class: "min-w-125px; text-left py-0"
}
const _hoisted_337 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-left" }, null, -1))
const _hoisted_338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-left",
  style: {"padding-left":"30px !important"}
}, " Total Biaya ", -1))
const _hoisted_339 = { class: "min-w-125px; text-left" }
const _hoisted_340 = { class: "row bd-highlight pt-1" }
const _hoisted_341 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pa-2 col-6 bd-highlight" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mt-1 fw-bold fs-7" }, "Catatan :"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger mt-1 fw-bold fs-7" }, [
    /*#__PURE__*/_createTextVNode("Menu ini berfungsi untuk menggabungkan dua atau lebih invoice dalam satu invoice "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" dengan satu kali proses pembayaran dan invoice lama akan terhapus")
  ])
], -1))
const _hoisted_342 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-left bd-highlight required",
  style: {"font-size":"large"}
}, " Pilih Bank Pembayaran ", -1))
const _hoisted_343 = { class: "p-3 col-3 bd-highlight" }
const _hoisted_344 = { class: "col-9" }
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Pilih BANK", -1))
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "BNI",
  key: "BNI"
}, "BANK BNI", -1))
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "BRI",
  key: "BRI"
}, "BANK BRI", -1))
const _hoisted_348 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "MANDIRI",
  key: "MANDIRI"
}, " BANK MANDIRI ", -1))
const _hoisted_349 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "PERMATA",
  key: "PERMATA"
}, " BANK PERMATA ", -1))
const _hoisted_350 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "BANKJATIM",
  key: "BANKJATIM"
}, " BANK JATIM SYARIAH ", -1))
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "MUAMALAT",
  key: "MUAMALAT"
}, " BANK MUAMALAT ", -1))
const _hoisted_352 = { class: "modal-footer" }
const _hoisted_353 = {
  key: 1,
  class: "modal-dialog-centered modal-dialog"
}
const _hoisted_354 = { class: "modal-content rounded" }
const _hoisted_355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, "Konfirmasi")
], -1))
const _hoisted_356 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_357 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Tagihan Untuk digabung minimal 2 Tagihan", -1))
const _hoisted_358 = [
  _hoisted_357
]
const _hoisted_359 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_360 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Anda Belum Memilih Invoice", -1))
const _hoisted_361 = [
  _hoisted_360
]
const _hoisted_362 = { class: "modal-footer" }
const _hoisted_363 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_364 = {
  key: 0,
  class: "modal-dialog modal-xl",
  style: {"min-width":"720px"}
}
const _hoisted_365 = { class: "modal-content" }
const _hoisted_366 = { class: "modal-header" }
const _hoisted_367 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column bd-highlight mb-3\" data-v-054c6549><div class=\"p-2 bd-highlight\" data-v-054c6549><h2 class=\"fw-bolder\" data-v-054c6549>Pembayaran Tagihan</h2></div><div class=\"p-2 bd-highlight\" data-v-054c6549><span class=\"text-muted mt-1 fw-bold fs-7\" data-v-054c6549>Pembayaran dan Penggabungan Tagihan</span></div></div>", 1)
const _hoisted_368 = { class: "modal-body" }
const _hoisted_369 = {
  class: "d-flex justify-content-between",
  style: {"gap":"2rem"}
}
const _hoisted_370 = {
  class: "d-flex flex-column align-item-center",
  style: {"flex-grow":"1"}
}
const _hoisted_371 = { class: "form-check mb-6" }
const _hoisted_372 = ["checked"]
const _hoisted_373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "selectAll" }, "Bayar Semua Tagihan", -1))
const _hoisted_374 = { class: "d-flex col-12 flex-wrap" }
const _hoisted_375 = { class: "col-lg-3 col-12" }
const _hoisted_376 = { style: {"width":"15rem"} }
const _hoisted_377 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Total", -1))
const _hoisted_378 = { class: "d-flex justify-content-start gap-2" }
const _hoisted_379 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Tagihan ", -1))
const _hoisted_380 = { class: "d-flex justify-content-start gap-2" }
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Digabungkan ", -1))
const _hoisted_382 = { class: "table-responsive table-wrapper" }
const _hoisted_383 = { class: "table tableFixHead align-middle gs-0 gy-4 mt-4" }
const _hoisted_384 = { style: {"position":"sticky","top":"0"} }
const _hoisted_385 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_386 = { class: "min-w-125px; text-center" }
const _hoisted_387 = ["checked"]
const _hoisted_388 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Pilih", -1))
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Tagihan", -1))
const _hoisted_390 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tagihan", -1))
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Qty", -1))
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Diskon", -1))
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tax", -1))
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah", -1))
const _hoisted_395 = { style: {"height":"fit-content"} }
const _hoisted_396 = ["data-bs-target", "aria-controls", "onClick"]
const _hoisted_397 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "data-bs-toogle": "tooltip",
  title: "detail"
}, null, -1))
const _hoisted_398 = [
  _hoisted_397
]
const _hoisted_399 = { class: "text-center" }
const _hoisted_400 = ["onClick", "checked"]
const _hoisted_401 = { class: "text-left" }
const _hoisted_402 = { class: "text-left" }
const _hoisted_403 = { class: "text-left" }
const _hoisted_404 = { class: "text-right" }
const _hoisted_405 = { class: "text-right" }
const _hoisted_406 = { class: "text-right" }
const _hoisted_407 = { class: "text-right" }
const _hoisted_408 = ["id"]
const _hoisted_409 = { colspan: "8" }
const _hoisted_410 = { class: "table-responsive px-5" }
const _hoisted_411 = { class: "table" }
const _hoisted_412 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Produk"),
    /*#__PURE__*/_createElementVNode("th", null, "Harga Satuan"),
    /*#__PURE__*/_createElementVNode("th", null, "Tax"),
    /*#__PURE__*/_createElementVNode("th", null, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty"),
    /*#__PURE__*/_createElementVNode("th", null, "Total")
  ])
], -1))
const _hoisted_413 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_414 = {
  class: "d-flex justify-content-between mt-2",
  style: {"margin-right":"2rem"}
}
const _hoisted_415 = { class: "col-lg-6 col-12" }
const _hoisted_416 = {
  class: "row",
  style: {"min-width":"15rem"}
}
const _hoisted_417 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Catatan", -1))
const _hoisted_418 = /*#__PURE__*/_createStaticVNode("<div class=\"row bd-highlight pt-1\" data-v-054c6549><div class=\"pa-2 bd-highlight\" data-v-054c6549><span class=\"mt-1 fw-bold fs-7\" data-v-054c6549>Informasi</span><br data-v-054c6549><ul data-v-054c6549><li class=\"text-muted mt-1 fw-bold fs-7\" data-v-054c6549> Jika terdapat tagihan yang memotong pendatan dari sistem psp maka akan didefaultkan dengan tidak ada pemotongan secara otomatis </li><li class=\"text-muted mt-1 fw-bold fs-7\" data-v-054c6549> *Invoice Top Up Manual yang di gabung, tidak bisa otomatis mengurangi saldo sumber dana dari PSP Admin, silahkan lakukan pencatatan pembayaran tagihan top up manual di PSP Admin </li></ul></div></div>", 1)
const _hoisted_419 = {
  class: "col-lg-4 col-12 text-right mt-4",
  style: {"min-width":"30%"}
}
const _hoisted_420 = { class: "d-flex justify-content-between gap-2" }
const _hoisted_421 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Sub Total", -1))
const _hoisted_422 = { class: "d-flex justify-content-between gap-2" }
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Diskon", -1))
const _hoisted_424 = { class: "d-flex justify-content-between gap-2" }
const _hoisted_425 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Pajak", -1))
const _hoisted_426 = { class: "d-flex justify-content-between gap-2" }
const _hoisted_427 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Total", -1))
const _hoisted_428 = { class: "d-flex justify-content-between gap-2" }
const _hoisted_429 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Sisa Tagihan", -1))
const _hoisted_430 = { class: "modal-footer" }
const _hoisted_431 = ["disabled"]
const _hoisted_432 = {
  key: 1,
  class: "modal-dialog-centered modal-dialog"
}
const _hoisted_433 = { class: "modal-content rounded" }
const _hoisted_434 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, "Konfirmasi")
], -1))
const _hoisted_435 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_436 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Tagihan Untuk digabung minimal 2 Tagihan", -1))
const _hoisted_437 = [
  _hoisted_436
]
const _hoisted_438 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_439 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Anda Belum Memilih Invoice", -1))
const _hoisted_440 = [
  _hoisted_439
]
const _hoisted_441 = { class: "modal-footer" }
const _hoisted_442 = {
  class: "modal",
  tabindex: "-1",
  id: "kt_modal_konfirm_manual",
  ref: "uploadModalRef",
  "data-bs-backdrop": "static"
}
const _hoisted_443 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_444 = { class: "modal-content rounded" }
const _hoisted_445 = { class: "modal-header" }
const _hoisted_446 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_447 = /*#__PURE__*/_createTextVNode(" Bayar Manual ")
const _hoisted_448 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Informasi Khusus ")
], -1))
const _hoisted_449 = [
  _hoisted_447,
  _hoisted_448
]
const _hoisted_450 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_451 = {
  key: 2,
  class: "modal-title"
}
const _hoisted_452 = { class: "modal-body pt-2" }
const _hoisted_453 = {
  key: 0,
  class: "row"
}
const _hoisted_454 = { class: "col-lg-12" }
const _hoisted_455 = { class: "row" }
const _hoisted_456 = { class: "col-lg-6" }
const _hoisted_457 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nomor Referensi ")
], -1))
const _hoisted_458 = {
  key: 0,
  class: "fv-plugins-message-container col-6"
}
const _hoisted_459 = { class: "fv-help-block" }
const _hoisted_460 = { class: "col-lg-6" }
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nama Rekening Pengirim ")
], -1))
const _hoisted_462 = {
  key: 0,
  class: "fv-plugins-message-container col-6"
}
const _hoisted_463 = { class: "fv-help-block" }
const _hoisted_464 = { class: "col-lg-12" }
const _hoisted_465 = { class: "row" }
const _hoisted_466 = { class: "col-lg-6" }
const _hoisted_467 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Rekening Tujuan ")
], -1))
const _hoisted_468 = { class: "col-lg-6" }
const _hoisted_469 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Persetujuan Finance ")
], -1))
const _hoisted_470 = { class: "col-lg-12" }
const _hoisted_471 = { class: "row" }
const _hoisted_472 = { class: "col-lg-6" }
const _hoisted_473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nomor Rekening ")
], -1))
const _hoisted_474 = { class: "col-lg-6" }
const _hoisted_475 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Catatan ")
], -1))
const _hoisted_476 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Informasi Khusus ")
], -1))
const _hoisted_477 = { class: "col-lg-12" }
const _hoisted_478 = { class: "row" }
const _hoisted_479 = { class: "col-lg-6" }
const _hoisted_480 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Penanggung Jawab ")
], -1))
const _hoisted_481 = {
  key: 0,
  class: "fv-plugins-message-container col-6"
}
const _hoisted_482 = { class: "fv-help-block" }
const _hoisted_483 = { class: "col-lg-6" }
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, "Tanggal Pembayaran", -1))
const _hoisted_485 = {
  key: 0,
  class: "fv-plugins-message-container col-6"
}
const _hoisted_486 = { class: "fv-help-block" }
const _hoisted_487 = { class: "col-lg-12" }
const _hoisted_488 = { class: "row" }
const _hoisted_489 = { class: "col-lg-6 mt-2" }
const _hoisted_490 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6 required" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Bukti Transfer"),
  /*#__PURE__*/_createElementVNode("span", null, "         "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "( Format .jpg .jpeg .png )")
], -1))
const _hoisted_491 = { class: "col-lg-6" }
const _hoisted_492 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Executor", -1))
const _hoisted_493 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_494 = { class: "fv-help-block" }
const _hoisted_495 = {
  key: 1,
  class: "row"
}
const _hoisted_496 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Pembayaran Manual Dibatalkan. ", -1))
const _hoisted_497 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Tagihan yang telah digabungkan akan menjadi satu invoice penagihan ", -1))
const _hoisted_498 = [
  _hoisted_496,
  _hoisted_497
]
const _hoisted_499 = {
  key: 2,
  class: "row"
}
const _hoisted_500 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"125px","margin-bottom":"15px","margin-top":"15px"},
    src: "/media/icons/checklist_icon.svg",
    alt: ""
  })
], -1))
const _hoisted_501 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Sukses Melakukan Pembayaran Manual ", -1))
const _hoisted_502 = [
  _hoisted_500,
  _hoisted_501
]
const _hoisted_503 = {
  key: 3,
  class: "row"
}
const _hoisted_504 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"125px","margin-bottom":"15px","margin-top":"15px"},
    src: "/media/icons/close_icon.svg",
    alt: ""
  })
], -1))
const _hoisted_505 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Gagal Melakukan Pembayaran Manual ", -1))
const _hoisted_506 = [
  _hoisted_504,
  _hoisted_505
]
const _hoisted_507 = {
  class: "modal-footer",
  style: {"align-self":"center"}
}
const _hoisted_508 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_menunggu",
  ref: "menungguModalRef"
}
const _hoisted_509 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-dialog\" data-v-054c6549><div class=\"modal-content\" data-v-054c6549><div class=\"modal-header btn-danger\" data-v-054c6549><h5 class=\"modal-title\" style=\"color:white;\" data-v-054c6549>Informasi</h5></div><div class=\"modal-body pt-2\" data-v-054c6549><div class=\"row\" data-v-054c6549><div class=\"col-lg-12\" style=\"text-align:center;\" data-v-054c6549><label class=\"col-lg-12 col-form-label fw-bold fs-6\" data-v-054c6549>Mohon menunggu, pembayaran anda sedang dilakukan pengecekan oleh tim keuangan \nPT Teknologi Kartu Indonesia</label></div></div></div><div class=\"modal-body pt-2\" data-v-054c6549><div class=\"row\" style=\"background-color:#e3ebfe;\" data-v-054c6549><div class=\"col-lg-12\" style=\"text-align:center;\" data-v-054c6549><label class=\"col-lg-12 fw-bold fs-6\" style=\"color:#e50200;font-size:12;\" data-v-054c6549>Apabila pembayaran anda belum terkonfirmasi selama 1x 24 jam, silahkan hubungi admin terkait.</label></div></div></div><div class=\"modal-footer\" style=\"align-self:center;\" data-v-054c6549><button type=\"button\" class=\"btn btn-danger\" style=\"width:100px;\" data-bs-dismiss=\"modal\" data-v-054c6549> Tutup </button></div></div></div>", 1)
const _hoisted_510 = [
  _hoisted_509
]
const _hoisted_511 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_konfirm_manual_fix",
  ref: "konfirmasiModalRef"
}
const _hoisted_512 = { class: "modal-dialog" }
const _hoisted_513 = { class: "modal-content" }
const _hoisted_514 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-054c6549><h5 class=\"modal-title\" data-v-054c6549>Konfirmasi Bayar Manual</h5></div><div class=\"modal-body pt-2\" data-v-054c6549><div class=\"row\" data-v-054c6549><div class=\"col-lg-12\" style=\"text-align:center;\" data-v-054c6549><label class=\"col-lg-12 col-form-label fw-bold fs-6\" data-v-054c6549>Apakah anda yakin akan melakukan pembayaran manual </label></div></div></div>", 2)
const _hoisted_516 = {
  class: "modal-footer",
  style: {"align-self":"center"}
}
const _hoisted_517 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_518 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_519 = ["label", "value"]
const _hoisted_520 = { class: "p-3" }
const _hoisted_521 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_522 = { class: "pagination" }
const _hoisted_523 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header ribbon ribbon-end\" data-v-054c6549><div class=\"ribbon-label bg-primary\" data-v-054c6549>Penjualan</div><div class=\"card-title\" data-v-054c6549><span class=\"d-flex flex-column\" data-v-054c6549><span class=\"fw-bolder fs-6\" data-v-054c6549>Detail Invoices</span><span class=\"fs-7 text-muted\" data-v-054c6549>Manajemen Data Sekolah</span></span></div></div>", 1)
const _hoisted_524 = { class: "card-body border-top p-9" }
const _hoisted_525 = { class: "row mb-6" }
const _hoisted_526 = { class: "col-lg-6 fv-row" }
const _hoisted_527 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "NO Order", -1))
const _hoisted_528 = { class: "col-lg-6 fv-row" }
const _hoisted_529 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "No VA", -1))
const _hoisted_530 = { class: "row mb-6" }
const _hoisted_531 = { class: "col-lg-6 fv-row" }
const _hoisted_532 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tanggal", -1))
const _hoisted_533 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Pelanggan")
], -1))
const _hoisted_534 = { class: "row mb-6" }
const _hoisted_535 = { class: "col-lg-6 fv-row" }
const _hoisted_536 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Sekolah", -1))
const _hoisted_537 = { class: "col-lg-6 fv-row" }
const _hoisted_538 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Jatuh Tempo", -1))
const _hoisted_539 = { class: "row mb-6" }
const _hoisted_540 = { class: "col-lg-6 fv-row" }
const _hoisted_541 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Alamat", -1))
const _hoisted_542 = { class: "row mb-6" }
const _hoisted_543 = { class: "col-lg-6 fv-row" }
const _hoisted_544 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Telp", -1))
const _hoisted_545 = { class: "row mb-6" }
const _hoisted_546 = { class: "col-lg-6 fv-row" }
const _hoisted_547 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "fax", -1))
const _hoisted_548 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Pelanggan")
], -1))
const _hoisted_549 = { class: "table-responsive" }
const _hoisted_550 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_551 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Kuantitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Harga"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Pajak"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah")
  ])
], -1))
const _hoisted_552 = { class: "text-left" }
const _hoisted_553 = { class: "text-left" }
const _hoisted_554 = { class: "text-left" }
const _hoisted_555 = { class: "text-left" }
const _hoisted_556 = { class: "text-left" }
const _hoisted_557 = { class: "text-left" }
const _hoisted_558 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left" }, null, -1))
const _hoisted_559 = { class: "text-left" }
const _hoisted_560 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_561 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_562 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-left" }, null, -1))
const _hoisted_563 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, null, -1))
const _hoisted_564 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, null, -1))
const _hoisted_565 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, null, -1))
const _hoisted_566 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, null, -1))
const _hoisted_567 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, "Subtotal", -1))
const _hoisted_568 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, null, -1))
const _hoisted_569 = { class: "min-w-150px; text-left" }
const _hoisted_570 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger mt-1 fw-bold fs-7" }, "Pajak auto 10%", -1))
const _hoisted_571 = { class: "row fv-row mb-6" }
const _hoisted_572 = { class: "d-flex bd-highlight" }
const _hoisted_573 = { class: "p-2 flex-fill bd-highlight" }
const _hoisted_574 = { class: "col-lg-6 fv-row" }
const _hoisted_575 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Terbilang", -1))
const _hoisted_576 = { class: "flex-fill justify-content-end" }
const _hoisted_577 = { class: "row no-gutters" }
const _hoisted_578 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-4 col-sm-6 col-md-8",
  style: {"padding-left":"22%"}
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "PPN")
], -1))
const _hoisted_579 = { class: "col-6 col-md-4" }
const _hoisted_580 = { class: "row no-gutters" }
const _hoisted_581 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-2 col-sm-6 col-md-8",
  style: {"padding-left":"22%"}
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Total")
], -1))
const _hoisted_582 = { class: "col-6 col-md-4 fw-bold" }
const _hoisted_583 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ModalDownloadInvoice = _resolveComponent("ModalDownloadInvoice")!
  const _component_Field = _resolveComponent("Field")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    (_ctx.konfirm)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.widgetClasses, "card"])
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listResume, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content",
                  key: `item-${index}`
                }, [
                  _createElementVNode("img", {
                    src: `/media/icons/invoice/${item.img}.svg`,
                    alt: ""
                  }, null, 8, _hoisted_6),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1),
                  _createElementVNode("span", null, _toDisplayString(item.isCurrency
                ? `Rp. ${_ctx.formatPrice(_ctx.resume[item.field] || 0)}`
                : _ctx.resume[item.field]), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_8, [
                (!_ctx.schoolId && _ctx.aksesBayarGabung == true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-primary me-3",
                      id: "btnBayar",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
              () => {
                _ctx.previewData();
                _ctx.modalOpen = false;
              }
            )
                    }, " Gabung Tagihan "))
                  : _createCommentVNode("", true),
                (_ctx.schoolId && _ctx.aksesBayarGabung == true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-sm btn-primary me-3",
                      id: "btnBayar",
                      type: "button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_1",
                      onClick: _cache[1] || (_cache[1] = 
              () => {
                _ctx.previewData();
                _ctx.modalOpen = true;
              }
            )
                    }, " Gabung Tagihan "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.role === 'SUPER_ADMIN' || _ctx.role === 'ADMIN_FINANCE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "btn btn-success",
                    "data-bs-toggle": "modal",
                    style: {"cursor":"pointer"},
                    "data-bs-target": "#kt_modal_3",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/superadmin/history-pembayaran-manual')))
                  }, " Report Pembayaran ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11)),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-md btn-primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.download()))
              }, " Unduh Data Tagihan "),
              _createVNode(_component_ModalDownloadInvoice, {
                url: 'crmv2/main_invoice/invoice/office/invoice/all/download',
                ListSchool: _ctx.ListSchool,
                schoolId: _ctx.schoolId,
                paymentStatus: _ctx.paymentStatus,
                onPilihSekolah: _ctx.pilihSekolah,
                onGantiStatus: _ctx.gantiStatus,
                role: _ctx.role
              }, null, 8, ["ListSchool", "schoolId", "paymentStatus", "onPilihSekolah", "onGantiStatus", "role"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Field, {
                as: "select",
                class: "form-select form-select-lg fw-bold",
                name: "paymentStatus",
                placeholder: "Isi Pilih Status",
                modelValue: _ctx.paymentStatus,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentStatus) = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getData(_ctx.paging.size, _ctx.paging.page)))
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("table", _hoisted_20, [
                _createElementVNode("thead", null, [
                  _hoisted_21,
                  _createElementVNode("tr", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createElementVNode("th", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "Cari Nomor Tagihan",
                        class: "form-control text-center",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.number) = $event)),
                        onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changePageSize && _ctx.changePageSize(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.number]
                      ])
                    ]),
                    _createElementVNode("th", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "Cari Nama Tagihan",
                        class: "form-control text-center",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.title) = $event)),
                        onKeyup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changePageSize && _ctx.changePageSize(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.title]
                      ])
                    ])
                  ])
                ]),
                (_ctx.tableData.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _hoisted_28,
                          (
                    item.paymentStatus == 'UNPAID' &&
                    _ctx.schoolSelected == true &&
                    _ctx.aksesBayarGabung == true
                  )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  class: "checkHistory",
                                  onClick: (e) => _ctx.handleSelected(index, item),
                                  value: item
                                }, null, 8, _hoisted_30)
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_31, "-")),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(item.number), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatTittle(item.title)), 1),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.formatDate(item.invoiceDate)), 1),
                          _createElementVNode("td", _hoisted_35, " Rp. " + _toDisplayString(_ctx.formatPrice(item.totalAmount)), 1),
                          (item.paymentStatus == 'UNPAID')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString("Belum Terbayar")))
                            : (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString("Terbayar"))),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.note), 1),
                          _createElementVNode("td", _hoisted_39, [
                            (_ctx.aksesBayar == true)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "symbol symbol-35px me-2",
                                  style: {"cursor":"pointer"},
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.cekStatus(item._id, item))
                                }, _hoisted_42, 8, _hoisted_40))
                              : _createCommentVNode("", true),
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Detail",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (
                      _ctx.$router.push('/sekolah/view-detail-invoices/' + item._id)
                    )
                            }, _hoisted_45, 8, _hoisted_43),
                            (
                      _ctx.aksesDelete == true &&
                      item.paymentStatus == 'UNPAID' &&
                      !item.joinInvoice
                    )
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "symbol symbol-35px me-2",
                                  "data-bs-toggle": "tooltip",
                                  title: "Hapus",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.handleDelete(index, item))
                                }, _hoisted_48, 8, _hoisted_46))
                              : _createCommentVNode("", true),
                            (
                      _ctx.aksesBayarGabung == true &&
                      item.paymentStatus == 'UNPAID' &&
                      item.joinInvoice
                    )
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "symbol symbol-35px me-2",
                                  "data-bs-toggle": "tooltip",
                                  title: "Split",
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.handleSplit(index, item))
                                }, _hoisted_51, 8, _hoisted_49))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_52, _hoisted_54))
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", {
                class: "modal fade",
                tabindex: "-1",
                id: "kt_modal_2",
                "validation-schema": _ctx.selectBank,
                "data-bs-backdrop": "static"
              }, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      (_ctx.paymentStatusInit == true)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_60, " Metode Pembayaran "))
                        : (_openBlock(), _createElementBlock("h5", _hoisted_61, " Metode Pembayaran " + _toDisplayString(_ctx.book.metodeName), 1))
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      (_ctx.paymentStatusInit == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, " Invoice Sudah Terbayar (Status PAID) "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            (
                      _ctx.dataPayment.paymentMethod == 'AUTOMATIC' &&
                      _ctx.dataPayment.paymentStatus == 'UNPAID'
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, [
                                    _createVNode(_component_vue_countdown, { time: _ctx.expDate }, {
                                      default: _withCtx(({ totalSeconds }) => [
                                        (totalSeconds > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, _hoisted_71))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_72, _hoisted_76))
                                      ]),
                                      _: 1
                                    }, 8, ["time"])
                                  ]),
                                  _createElementVNode("div", _hoisted_77, [
                                    (_ctx.sumber == 'Topup Manual' && _ctx.showFormCoa === false)
                                      ? (_openBlock(), _createElementBlock("h4", _hoisted_78, _toDisplayString(_ctx.checkDataPayment.data.callbacks.length !== 0 &&
                          _ctx.checkDataPayment.data.callbacks[0].coaCode !== ""
                            ? "Sumber Dana :" +
                              _ctx.checkDataPayment.data.callbacks[0].coaCode
                            : ""), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("h4", _hoisted_79, [
                                      _hoisted_80,
                                      _createElementVNode("span", null, " : " + _toDisplayString(_ctx.dataPayment.vaName), 1)
                                    ]),
                                    _createElementVNode("h4", _hoisted_81, [
                                      _hoisted_82,
                                      _createVNode(_component_vue_countdown, { time: _ctx.expDate }, {
                                        default: _withCtx(({ totalSeconds }) => [
                                          (totalSeconds > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                                                _hoisted_84,
                                                _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.dataPayment.vaNumber), 1)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_86, [
                                                _hoisted_87,
                                                _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.dataPayment.vaNumber), 1)
                                              ]))
                                        ]),
                                        _: 1
                                      }, 8, ["time"])
                                    ]),
                                    _createElementVNode("h4", _hoisted_89, [
                                      _hoisted_90,
                                      _createElementVNode("span", null, " : " + _toDisplayString(_ctx.dataPayment.vaBank), 1)
                                    ]),
                                    _createElementVNode("h4", _hoisted_91, [
                                      _hoisted_92,
                                      _createElementVNode("span", null, " : " + _toDisplayString(_ctx.formatDateTime(_ctx.showExpVaNumber)), 1)
                                    ]),
                                    _createVNode(_component_vue_countdown, { time: _ctx.expDate }, {
                                      default: _withCtx(({ days, hours, minutes, seconds, totalSeconds }) => [
                                        (totalSeconds > 0)
                                          ? (_openBlock(), _createElementBlock("h4", _hoisted_93, [
                                              _hoisted_94,
                                              _createElementVNode("span", _hoisted_95, _toDisplayString(days > 0 ? `${days} hari` : "") + " " + _toDisplayString(hours > 9 ? hours : "0" + hours) + " : " + _toDisplayString(minutes > 9 ? minutes : "0" + minutes) + " : " + _toDisplayString(seconds > 9 ? seconds : "0" + seconds), 1)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                              _hoisted_97,
                                              _createElementVNode("button", {
                                                class: "btn btn-outline btn-outline-danger btn-active-light-danger mb-2",
                                                style: {"margin-right":"auto"},
                                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.paymentByID(true)))
                                              }, " Perbaharui Virual Account ")
                                            ]))
                                      ]),
                                      _: 1
                                    }, 8, ["time"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                      _ctx.dataPayment.paymentMethod == 'MANUAL' &&
                      _ctx.dataPayment.paymentStatus == 'UNPAID'
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                  (_ctx.sumber == 'Topup Manual' && _ctx.showFormCoa === false)
                                    ? (_openBlock(), _createElementBlock("h4", _hoisted_99, _toDisplayString(_ctx.checkDataPayment.data.callbacks.length !== 0 &&
                        _ctx.checkDataPayment.data.callbacks[0].coaCode !== ""
                          ? "Sumber Dana :" +
                            _ctx.checkDataPayment.data.callbacks[0].coaCode
                          : ""), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("h4", null, "Nama Bank : " + _toDisplayString(_ctx.checkDataPayment.data.vaBank), 1),
                                  _createElementVNode("h4", null, " Nomor Rekening Tujuan : " + _toDisplayString(_ctx.returnBankName(_ctx.checkDataPayment.data.vaBank)), 1),
                                  _createElementVNode("h4", null, " Nama Rekening Tujuan : " + _toDisplayString(_ctx.returnAcontName(_ctx.checkDataPayment.data.vaBank)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (
                      _ctx.dataPayment.paymentMethod == null ||
                      _ctx.dataPayment.paymentMethod == ''
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                  _hoisted_101,
                                  _createElementVNode("div", _hoisted_102, [
                                    _createElementVNode("div", _hoisted_103, [
                                      _createVNode(_component_Field, {
                                        as: "select",
                                        class: "form-select form-select-lg fw-bold",
                                        name: "metodeName",
                                        modelValue: _ctx.book.metodeName,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.book.metodeName) = $event)),
                                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeMetode($event)))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_104,
                                          _hoisted_105
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ])
                                  ]),
                                  (_ctx.sumber == 'Topup Manual')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, " Sumber Dana "))
                                    : _createCommentVNode("", true),
                                  (_ctx.sumber == 'Topup Manual')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                        _hoisted_108,
                                        (_ctx.sumber == 'Topup Manual')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_109))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input",
                                          type: "checkbox",
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showFormCoa) = $event))
                                        }, null, 512), [
                                          [_vModelCheckbox, _ctx.showFormCoa]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.sumber == 'Topup Manual' && !_ctx.showFormCoa)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                        _hoisted_111,
                                        _createElementVNode("div", _hoisted_112, [
                                          _createElementVNode("div", _hoisted_113, [
                                            _createVNode(_component_Multiselect, {
                                              modelValue: _ctx.book.sumberdana,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.book.sumberdana) = $event)),
                                              placeholder: "Pilih Sumber Dana Terlebih Dahulu",
                                              mode: "single",
                                              "create-option": false,
                                              options: _ctx.listcoa,
                                              searchable: true,
                                              label: "names",
                                              "track-by": "names",
                                              "value-prop": "code",
                                              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getbalance($event)))
                                            }, null, 8, ["modelValue", "options"]),
                                            (_ctx.balanceCoa > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_114, " Saldo : " + _toDisplayString(_ctx.balanceCoa), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_115)),
                                            (_ctx.book.sumberdana != '')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_116, _hoisted_118))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                  _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.error2.selectBank2), 1)
                                                ]))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_121,
                                  _createElementVNode("div", _hoisted_122, [
                                    _createElementVNode("div", _hoisted_123, [
                                      (_ctx.book.metodeName == 'Manual')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            as: "select",
                                            class: "form-select form-select-lg fw-bold",
                                            name: "bankName",
                                            modelValue: _ctx.bankManual,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.bankManual) = $event)),
                                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changebankManual($event)))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_124,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBankManual, (i, idx) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  value: i.bankName,
                                                  key: idx
                                                }, _toDisplayString(i.bankName), 9, _hoisted_125))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_126, [
                                      (_ctx.book.metodeName == 'Otomatis')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            as: "select",
                                            class: "form-select form-select-lg fw-bold",
                                            name: "bankName",
                                            modelValue: _ctx.book.bankName,
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.book.bankName) = $event)),
                                            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.getTutorial($event.target.value))),
                                            placeholder: "Pilih Bank"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_127,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBankOtomatis, (i, idx) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  value: i.bankCode,
                                                  key: idx
                                                }, _toDisplayString(i.bankName), 9, _hoisted_128))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.book.bankName != '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_129, _hoisted_131))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                            _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.error1.selectBank1), 1)
                                          ]))
                                    ])
                                  ]),
                                  (_ctx.book.metodeName == 'Manual')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                        _hoisted_135,
                                        _createElementVNode("div", _hoisted_136, [
                                          _createElementVNode("div", _hoisted_137, [
                                            _createVNode(_component_Field, {
                                              type: "text",
                                              name: "progress_responsible",
                                              class: "form-control form-control-lg",
                                              modelValue: _ctx.targetKonfirmasi.rekTujuan,
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.targetKonfirmasi.rekTujuan) = $event)),
                                              disabled: ""
                                            }, null, 8, ["modelValue"]),
                                            (_ctx.targetKonfirmasi.rekTujuan != '')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_138, _hoisted_140))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                                  _createElementVNode("div", _hoisted_142, _toDisplayString(_ctx.error1.selectBank1), 1)
                                                ]))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_143
                                ]))
                              : _createCommentVNode("", true),
                            (
                      (_ctx.book.metodeName == 'Manual' ||
                        _ctx.dataPayment.paymentMethod == 'Manual') &&
                      _ctx.paymentStatusInit == false
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_144, " Setelah pembayaran selesai, Silahkan konfirmasi ke Tim Finance "))
                              : _createCommentVNode("", true),
                            (_ctx.paymentStatusInit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_145, " Status Invoice Telah dibayar "))
                              : _createCommentVNode("", true),
                            (
                      (_ctx.book.metodeName == 'Otomatis' ||
                        _ctx.dataPayment.paymentMethod == 'Otomatis') &&
                      _ctx.paymentStatusInit == false
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_146, " Status pembayaran akan berubah secara otomatis setelah invoice terbayar "))
                              : _createCommentVNode("", true),
                            (_ctx.previewPembayaranSingle == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                  _createElementVNode("table", _hoisted_148, [
                                    _hoisted_149,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.book.preview.detail, (q, index) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                          _createElementVNode("td", _hoisted_150, _toDisplayString(index + 1), 1),
                                          _createElementVNode("td", _hoisted_151, _toDisplayString(q.name), 1),
                                          _createElementVNode("td", _hoisted_152, " Rp. " + _toDisplayString(_ctx.formatPrice(q.price)), 1),
                                          _createElementVNode("td", _hoisted_153, _toDisplayString(q.qty), 1),
                                          _createElementVNode("td", _hoisted_154, _toDisplayString(q.discount) + " %", 1),
                                          _createElementVNode("td", _hoisted_155, _toDisplayString(q.tax) + " %", 1),
                                          _hoisted_156,
                                          _createElementVNode("td", _hoisted_157, " Rp. " + _toDisplayString(_ctx.formatPrice(q.amount)), 1)
                                        ]))
                                      }), 128))
                                    ]),
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", _hoisted_158, [
                                        _hoisted_159,
                                        _hoisted_160,
                                        _hoisted_161,
                                        _hoisted_162,
                                        _hoisted_163,
                                        _hoisted_164,
                                        _hoisted_165,
                                        _createElementVNode("th", _hoisted_166, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.amount)), 1)
                                      ]),
                                      _createElementVNode("tr", _hoisted_167, [
                                        _hoisted_168,
                                        _hoisted_169,
                                        _hoisted_170,
                                        _hoisted_171,
                                        _hoisted_172,
                                        _hoisted_173,
                                        _hoisted_174,
                                        _createElementVNode("th", _hoisted_175, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.tax)), 1)
                                      ]),
                                      _createElementVNode("tr", _hoisted_176, [
                                        _hoisted_177,
                                        _hoisted_178,
                                        _hoisted_179,
                                        _hoisted_180,
                                        _hoisted_181,
                                        _hoisted_182,
                                        _hoisted_183,
                                        _createElementVNode("th", _hoisted_184, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.discount)), 1)
                                      ]),
                                      _createElementVNode("tr", _hoisted_185, [
                                        _hoisted_186,
                                        _hoisted_187,
                                        _hoisted_188,
                                        _hoisted_189,
                                        _hoisted_190,
                                        _hoisted_191,
                                        _hoisted_192,
                                        _createElementVNode("th", _hoisted_193, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.shipping)), 1)
                                      ]),
                                      _createElementVNode("tr", _hoisted_194, [
                                        _hoisted_195,
                                        _hoisted_196,
                                        _hoisted_197,
                                        _hoisted_198,
                                        _hoisted_199,
                                        _hoisted_200,
                                        _hoisted_201,
                                        _createElementVNode("th", _hoisted_202, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.totalAmount)), 1)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.previewPembayaranSingle == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                  _createElementVNode("div", _hoisted_204, [
                                    _createElementVNode("div", _hoisted_205, [
                                      _createElementVNode("div", _hoisted_206, [
                                        _hoisted_207,
                                        _createVNode(_component_Field, {
                                          type: "text",
                                          name: "number",
                                          class: "form-control d-flex form-control-lg",
                                          modelValue: _ctx.book.preview.vaNumber,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.book.preview.vaNumber) = $event)),
                                          disabled: ""
                                        }, null, 8, ["modelValue"])
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_208, [
                      _createElementVNode("div", _hoisted_209, [
                        _createElementVNode("div", _hoisted_210, [
                          _hoisted_211,
                          _createElementVNode("div", _hoisted_212, [
                            _createElementVNode("div", { innerHTML: _ctx.tutorial }, null, 8, _hoisted_213)
                          ]),
                          _hoisted_214
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_215, [
                      (
                    _ctx.showtutorial &&
                    _ctx.dataPayment.paymentMethod != '' &&
                    _ctx.dataPayment.paymentMethod != null &&
                    _ctx.paymentStatusInit == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-outline btn-outline-success btn-active-light-success mb-2",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.bantuanModal())),
                            style: {"margin-right":"auto"}
                          }, " Bantuan "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.dataPayment.paymentMethod != '' &&
                    _ctx.dataPayment.paymentMethod != null &&
                    _ctx.paymentStatusInit == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-warning",
                            "data-bs-dismiss": "modal",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.changeBank('Manual')))
                          }, " Ganti Metode Pembayaran "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.dataPayment.paymentMethod == 'MANUAL' &&
                    _ctx.paymentStatusInit == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-primary",
                            "data-bs-dismiss": "modal",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.bayarManualSingle('Manual')))
                          }, " Konfirmasi "))
                        : _createCommentVNode("", true),
                      (_ctx.previewPembayaranSingle == true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.clickReset())),
                            "data-bs-dismiss": "modal"
                          }, " Tutup "))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.clickReset()))
                      }, " Tutup "),
                      (
                    (_ctx.dataPayment.paymentMethod == null ||
                      _ctx.dataPayment.paymentMethod == '') &&
                    _ctx.paymentStatusInit == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.paymentByID()), ["prevent"]))
                          }, " Simpan "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 8, _hoisted_56)
            ]),
            _createElementVNode("div", _hoisted_216, [
              _createElementVNode("div", _hoisted_217, [
                _createElementVNode("div", _hoisted_218, [
                  _createElementVNode("div", _hoisted_219, [
                    _hoisted_220,
                    _createElementVNode("div", _hoisted_221, [
                      _createElementVNode("div", _hoisted_222, [
                        _createElementVNode("table", _hoisted_223, [
                          _hoisted_224,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.book.preview.detail, (q, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_225, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", _hoisted_226, _toDisplayString(q.name), 1),
                                _createElementVNode("td", _hoisted_227, " Rp. " + _toDisplayString(_ctx.formatPrice(q.price)), 1),
                                _createElementVNode("td", _hoisted_228, _toDisplayString(q.qty), 1),
                                _createElementVNode("td", _hoisted_229, _toDisplayString(q.discount) + " %", 1),
                                _createElementVNode("td", _hoisted_230, _toDisplayString(q.tax) + " %", 1),
                                _hoisted_231,
                                _createElementVNode("td", _hoisted_232, " Rp. " + _toDisplayString(_ctx.formatPrice(q.amount)), 1)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_233, [
                              _hoisted_234,
                              _hoisted_235,
                              _hoisted_236,
                              _hoisted_237,
                              _hoisted_238,
                              _hoisted_239,
                              _hoisted_240,
                              _createElementVNode("th", _hoisted_241, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.amount)), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_242, [
                              _hoisted_243,
                              _hoisted_244,
                              _hoisted_245,
                              _hoisted_246,
                              _hoisted_247,
                              _hoisted_248,
                              _hoisted_249,
                              _createElementVNode("th", _hoisted_250, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.tax)), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_251, [
                              _hoisted_252,
                              _hoisted_253,
                              _hoisted_254,
                              _hoisted_255,
                              _hoisted_256,
                              _hoisted_257,
                              _hoisted_258,
                              _createElementVNode("th", _hoisted_259, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.discount)), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_260, [
                              _hoisted_261,
                              _hoisted_262,
                              _hoisted_263,
                              _hoisted_264,
                              _hoisted_265,
                              _hoisted_266,
                              _hoisted_267,
                              _createElementVNode("th", _hoisted_268, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.shipping)), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_269, [
                              _hoisted_270,
                              _hoisted_271,
                              _hoisted_272,
                              _hoisted_273,
                              _hoisted_274,
                              _hoisted_275,
                              _hoisted_276,
                              _createElementVNode("th", _hoisted_277, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.book.preview.totalAmount)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_278, [
                        _createElementVNode("div", _hoisted_279, [
                          _createElementVNode("div", _hoisted_280, [
                            _createElementVNode("div", _hoisted_281, [
                              _hoisted_282,
                              _createVNode(_component_Field, {
                                type: "text",
                                name: "number",
                                class: "form-control d-flex form-control-lg",
                                modelValue: _ctx.book.preview.vaNumber,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.book.preview.vaNumber) = $event)),
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_283
                  ])
                ])
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_284, [
              _createElementVNode("div", _hoisted_285, [
                _createElementVNode("div", _hoisted_286, [
                  (_ctx.btnBayar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                        _createElementVNode("div", _hoisted_288, [
                          _hoisted_289,
                          _createElementVNode("div", _hoisted_290, [
                            _createElementVNode("div", _hoisted_291, [
                              _createElementVNode("table", _hoisted_292, [
                                _hoisted_293,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.book.invoice.detail, (x, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                      _createElementVNode("td", _hoisted_294, _toDisplayString(index + 1), 1),
                                      _createElementVNode("td", _hoisted_295, _toDisplayString(x.name), 1),
                                      _createElementVNode("td", _hoisted_296, _toDisplayString(_ctx.note), 1),
                                      _createElementVNode("td", _hoisted_297, " Rp. " + _toDisplayString(_ctx.formatPrice(x.price)), 1),
                                      _createElementVNode("td", _hoisted_298, _toDisplayString(x.qty), 1),
                                      _createElementVNode("td", _hoisted_299, _toDisplayString(x.discount) + " %", 1),
                                      _createElementVNode("td", _hoisted_300, _toDisplayString(x.tax) + " %", 1)
                                    ]))
                                  }), 128))
                                ]),
                                _hoisted_301,
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", _hoisted_302, [
                                    _hoisted_303,
                                    _hoisted_304,
                                    _hoisted_305,
                                    _hoisted_306,
                                    _hoisted_307,
                                    _hoisted_308,
                                    _createElementVNode("th", _hoisted_309, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.amount)), 1)
                                  ])
                                ]),
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", _hoisted_310, [
                                    _hoisted_311,
                                    _hoisted_312,
                                    _hoisted_313,
                                    _hoisted_314,
                                    _hoisted_315,
                                    _hoisted_316,
                                    _createElementVNode("th", _hoisted_317, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.discount)), 1)
                                  ])
                                ]),
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", _hoisted_318, [
                                    _hoisted_319,
                                    _hoisted_320,
                                    _hoisted_321,
                                    _hoisted_322,
                                    _hoisted_323,
                                    _hoisted_324,
                                    _createElementVNode("th", _hoisted_325, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.tax)), 1)
                                  ])
                                ]),
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", _hoisted_326, [
                                    _hoisted_327,
                                    _hoisted_328,
                                    _hoisted_329,
                                    _hoisted_330,
                                    _hoisted_331,
                                    _hoisted_332,
                                    _createElementVNode("th", _hoisted_333, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.shipping)), 1)
                                  ])
                                ]),
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", _hoisted_334, [
                                    _hoisted_335,
                                    _createElementVNode("th", _hoisted_336, [
                                      _createVNode(_component_Field, {
                                        type: "text",
                                        name: "note",
                                        class: "form-control form-control-lg",
                                        disabled: "",
                                        modelValue: _ctx.wordCurrency,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.wordCurrency) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_337,
                                    _hoisted_338,
                                    _createElementVNode("th", _hoisted_339, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.totalAmount)), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_340, [
                                _hoisted_341,
                                _hoisted_342,
                                _createElementVNode("div", _hoisted_343, [
                                  _createElementVNode("div", _hoisted_344, [
                                    _createVNode(_component_Field, {
                                      as: "select",
                                      class: "form-select form-select-lg fw-bold",
                                      name: "bankName",
                                      modelValue: _ctx.book.bankName,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.book.bankName) = $event)),
                                      onChange: _ctx.selectBank
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_345,
                                        _hoisted_346,
                                        _hoisted_347,
                                        _hoisted_348,
                                        _hoisted_349,
                                        _hoisted_350,
                                        _hoisted_351
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_352, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger",
                              "data-bs-dismiss": "modal",
                              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.clickReset()))
                            }, " Batal "),
                            _createElementVNode("button", {
                              type: "button",
                              disabled: "",
                              id: "submitBayarManual",
                              class: "btn btn-primary",
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.submitBayarManual())),
                              "data-bs-dismiss": "modal"
                            }, " Konfirmasi ")
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_353, [
                        _createElementVNode("div", _hoisted_354, [
                          _hoisted_355,
                          (_ctx.statusBayar)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_356, _hoisted_358))
                            : (_openBlock(), _createElementBlock("div", _hoisted_359, _hoisted_361)),
                          _createElementVNode("div", _hoisted_362, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger",
                              "data-bs-dismiss": "modal",
                              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.clickReset()))
                            }, " Kembali ")
                          ])
                        ])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_363, [
                  (_ctx.btnBayar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_364, [
                        _createElementVNode("div", _hoisted_365, [
                          _createElementVNode("div", _hoisted_366, [
                            _hoisted_367,
                            _createElementVNode("div", {
                              class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                              "data-bs-dismiss": "modal",
                              "aria-label": "Close",
                              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.modalOpen = false))
                            })
                          ]),
                          _createElementVNode("div", _hoisted_368, [
                            _createElementVNode("div", _hoisted_369, [
                              _createElementVNode("div", _hoisted_370, [
                                _createElementVNode("div", _hoisted_371, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "checkHistory form-check-input",
                                    id: "selectAll",
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleSelectedAll())),
                                    checked: _ctx.selectAll
                                  }, null, 8, _hoisted_372),
                                  _hoisted_373
                                ]),
                                _createElementVNode("div", _hoisted_374, [
                                  _createElementVNode("div", _hoisted_375, [
                                    _createVNode(_component_el_date_picker, {
                                      class: "",
                                      modelValue: _ctx.dateAll,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dateAll) = $event)),
                                      type: "daterange",
                                      "start-placeholder": "Tanggal Awal",
                                      "end-placeholder": "Tanggal Akhir",
                                      "value-format": "YYYY-MM-DD",
                                      onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.pilihTanggalAll()))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_376, [
                                _hoisted_377,
                                _createElementVNode("h3", null, "Rp." + _toDisplayString(_ctx.formatPrice(_ctx.mergeData.totalAmount || 0)), 1),
                                _createElementVNode("div", _hoisted_378, [
                                  _hoisted_379,
                                  _createElementVNode("span", null, ": " + _toDisplayString(_ctx.previewDatas.length), 1)
                                ]),
                                _createElementVNode("div", _hoisted_380, [
                                  _hoisted_381,
                                  _createElementVNode("span", null, ": " + _toDisplayString(_ctx.selected.length), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_382, [
                              _createElementVNode("table", _hoisted_383, [
                                _createElementVNode("thead", _hoisted_384, [
                                  _createElementVNode("tr", _hoisted_385, [
                                    _createElementVNode("th", _hoisted_386, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        id: "selectAll",
                                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.collapseAll())),
                                        checked: _ctx.collapsedAll
                                      }, null, 8, _hoisted_387)
                                    ]),
                                    _hoisted_388,
                                    _hoisted_389,
                                    _hoisted_390,
                                    _hoisted_391,
                                    _hoisted_392,
                                    _hoisted_393,
                                    _hoisted_394
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewDatas, (x, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      _createElementVNode("tr", _hoisted_395, [
                                        _createElementVNode("td", {
                                          "data-bs-toggle": "collapse",
                                          "data-bs-target": `#row-${index}`,
                                          "aria-expanded": "true",
                                          "aria-controls": `row-${index}`,
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (_ctx.collapsed[index] = !_ctx.collapsed[index])
                                        }, _hoisted_398, 8, _hoisted_396),
                                        _createElementVNode("td", _hoisted_399, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            class: "checkHistory",
                                            onClick: ($event: any) => (_ctx.handleSelected(index, x)),
                                            checked: _ctx.selectedId.includes(x._id)
                                          }, null, 8, _hoisted_400)
                                        ]),
                                        _createElementVNode("td", _hoisted_401, _toDisplayString(x.number), 1),
                                        _createElementVNode("td", _hoisted_402, _toDisplayString(x.title), 1),
                                        _createElementVNode("td", _hoisted_403, " Rp. " + _toDisplayString(_ctx.formatPrice(x.amount)), 1),
                                        _createElementVNode("td", _hoisted_404, " Rp. " + _toDisplayString(_ctx.formatPrice(x.discount)), 1),
                                        _createElementVNode("td", _hoisted_405, " Rp. " + _toDisplayString(_ctx.formatPrice(x.tax)), 1),
                                        _createElementVNode("td", _hoisted_406, " Rp. " + _toDisplayString(_ctx.formatPrice(x.totalAmount)), 1),
                                        _createElementVNode("td", _hoisted_407, _toDisplayString(x.qty), 1)
                                      ]),
                                      _createElementVNode("tr", {
                                        id: `row-${index}`,
                                        class: _normalizeClass(`collapse ${_ctx.collapsed[index] && 'show'}`)
                                      }, [
                                        _createElementVNode("td", _hoisted_409, [
                                          _createElementVNode("div", _hoisted_410, [
                                            _createElementVNode("table", _hoisted_411, [
                                              _hoisted_412,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(x.detail, (detail, indexDetail) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: `${detail._id}-${indexDetail}`
                                                  }, [
                                                    _createElementVNode("td", null, _toDisplayString(detail.name), 1),
                                                    _createElementVNode("td", null, " Rp. " + _toDisplayString(_ctx.formatPrice(detail.price)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(detail.tax) + " %", 1),
                                                    _createElementVNode("td", null, _toDisplayString(detail.discount), 1),
                                                    _createElementVNode("td", null, _toDisplayString(detail.qty), 1),
                                                    _createElementVNode("td", null, " Rp. " + _toDisplayString(_ctx.formatPrice(detail.amount)), 1)
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ], 10, _hoisted_408)
                                    ], 64))
                                  }), 128))
                                ]),
                                _hoisted_413
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_414, [
                              _createElementVNode("div", _hoisted_415, [
                                _createElementVNode("div", _hoisted_416, [
                                  _hoisted_417,
                                  _withDirectives(_createElementVNode("textarea", {
                                    type: "textarea",
                                    name: "merchant",
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.mergeData.note) = $event)),
                                    class: "form-control form-control-sm"
                                  }, null, 512), [
                                    [_vModelText, _ctx.mergeData.note]
                                  ])
                                ]),
                                _hoisted_418
                              ]),
                              _createElementVNode("div", _hoisted_419, [
                                _createElementVNode("div", _hoisted_420, [
                                  _hoisted_421,
                                  _createElementVNode("span", null, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.mergeData.amount || 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_422, [
                                  _hoisted_423,
                                  _createElementVNode("span", null, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.mergeData.discount || 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_424, [
                                  _hoisted_425,
                                  _createElementVNode("span", null, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.mergeData.tax || 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_426, [
                                  _hoisted_427,
                                  _createElementVNode("span", null, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.mergeData.totalAmount || 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_428, [
                                  _hoisted_429,
                                  _createElementVNode("span", null, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.mergeData.totalAmount || 0)), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_430, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger",
                              "data-bs-dismiss": "modal",
                              onClick: _cache[40] || (_cache[40] = () => _ctx.clickReset())
                            }, " Batal "),
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.previewDatas.length < 1 || _ctx.selected.length < 2,
                              id: "submitAddInvoices",
                              class: "btn btn-primary",
                              onClick: _cache[41] || (_cache[41] = () => _ctx.submitAddInvoices()),
                              "data-bs-dismiss": "modal"
                            }, " Konfirmasi ", 8, _hoisted_431)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_432, [
                        _createElementVNode("div", _hoisted_433, [
                          _hoisted_434,
                          (_ctx.statusBayar)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_435, _hoisted_437))
                            : (_openBlock(), _createElementBlock("div", _hoisted_438, _hoisted_440)),
                          _createElementVNode("div", _hoisted_441, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger",
                              "data-bs-dismiss": "modal",
                              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.clickReset()))
                            }, " Kembali ")
                          ])
                        ])
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_442, [
                _createElementVNode("div", _hoisted_443, [
                  _createElementVNode("div", _hoisted_444, [
                    _createElementVNode("div", _hoisted_445, [
                      (_ctx.resultBayarManual == false)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_446, _hoisted_449))
                        : _createCommentVNode("", true),
                      (_ctx.resultBayarManual == true && _ctx.successBayarManual == true)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_450, " Berhasil "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.resultBayarManual == true && _ctx.successBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_451, " Gagal "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_452, [
                      (
                    _ctx.buttonBayarManualSingle == false &&
                    _ctx.resultBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_453, [
                            _createElementVNode("div", _hoisted_454, [
                              _createElementVNode("div", _hoisted_455, [
                                _createElementVNode("div", _hoisted_456, [
                                  _hoisted_457,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "noRef",
                                    class: "form-control form-control-lg",
                                    placeholder: "",
                                    modelValue: _ctx.targetKonfirmasi.noRef,
                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.targetKonfirmasi.noRef) = $event))
                                  }, null, 8, ["modelValue"]),
                                  (
                            _ctx.targetKonfirmasi.noRef == '' &&
                            _ctx.errorBayarManual.noRef != ''
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_458, [
                                        _createElementVNode("div", _hoisted_459, _toDisplayString(_ctx.errorBayarManual.noRef), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_460, [
                                  _hoisted_461,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "nmSend",
                                    class: "form-control form-control-lg",
                                    placeholder: "",
                                    modelValue: _ctx.targetKonfirmasi.namaPengirim,
                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.targetKonfirmasi.namaPengirim) = $event))
                                  }, null, 8, ["modelValue"]),
                                  (
                            _ctx.targetKonfirmasi.namaPengirim == '' &&
                            _ctx.errorBayarManual.namaPengirim != ''
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_462, [
                                        _createElementVNode("div", _hoisted_463, _toDisplayString(_ctx.errorBayarManual.namaPengirim), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_464, [
                              _createElementVNode("div", _hoisted_465, [
                                _createElementVNode("div", _hoisted_466, [
                                  _hoisted_467,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "namarekTujuan",
                                    class: "form-control form-control-lg",
                                    modelValue: _ctx.targetKonfirmasi.namaRektujuan,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.targetKonfirmasi.namaRektujuan) = $event)),
                                    disabled: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_468, [
                                  _hoisted_469,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "persetujuanFinance",
                                    class: "form-control form-control-lg",
                                    placeholder: "",
                                    modelValue: _ctx.targetKonfirmasi.persetujuanFinance,
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.targetKonfirmasi.persetujuanFinance) = $event)),
                                    disabled: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_470, [
                              _createElementVNode("div", _hoisted_471, [
                                _createElementVNode("div", _hoisted_472, [
                                  _hoisted_473,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "retujuan",
                                    class: "form-control form-control-lg",
                                    modelValue: _ctx.targetKonfirmasi.rekTujuan,
                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.targetKonfirmasi.rekTujuan) = $event)),
                                    disabled: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_474, [
                                  _hoisted_475,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "note",
                                    class: "form-control form-control-lg",
                                    placeholder: "",
                                    modelValue: _ctx.targetKonfirmasi.note,
                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.targetKonfirmasi.note) = $event))
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            _hoisted_476,
                            _createElementVNode("div", _hoisted_477, [
                              _createElementVNode("div", _hoisted_478, [
                                _createElementVNode("div", _hoisted_479, [
                                  _hoisted_480,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: "penanggungJawab",
                                    class: "form-control form-control-lg",
                                    modelValue: _ctx.targetKonfirmasi.penanggungJawab,
                                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.targetKonfirmasi.penanggungJawab) = $event))
                                  }, null, 8, ["modelValue"]),
                                  (
                            _ctx.targetKonfirmasi.penanggungJawab == '' &&
                            _ctx.errorBayarManual.penanggungJawab != ''
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_481, [
                                        _createElementVNode("div", _hoisted_482, _toDisplayString(_ctx.errorBayarManual.penanggungJawab), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_483, [
                                  _hoisted_484,
                                  _createVNode(_component_Field, {
                                    type: "date",
                                    name: "tanggal",
                                    class: "form-control form-control-lg",
                                    placeholder: "Isi Tanggal Pembayaran",
                                    modelValue: _ctx.targetKonfirmasi.tanggal,
                                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.targetKonfirmasi.tanggal) = $event))
                                  }, null, 8, ["modelValue"]),
                                  (
                            _ctx.targetKonfirmasi.tanggal == '' &&
                            _ctx.errorBayarManual.tanggal != ''
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_485, [
                                        _createElementVNode("div", _hoisted_486, _toDisplayString(_ctx.errorBayarManual.tanggal), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_487, [
                              _createElementVNode("div", _hoisted_488, [
                                _createElementVNode("div", _hoisted_489, [
                                  _hoisted_490,
                                  (_openBlock(), _createElementBlock("input", {
                                    name: "fotobuktitf",
                                    type: "file",
                                    id: "fotobuktitf",
                                    class: "form-control form-control-lg",
                                    onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.handleFotoImageBuktiTF($event))),
                                    key: _ctx.fileInputKey3
                                  }, null, 32))
                                ]),
                                _createElementVNode("div", _hoisted_491, [
                                  _hoisted_492,
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    disabled: "",
                                    name: "Executor",
                                    class: "form-control form-control-lg",
                                    modelValue: _ctx.name_user,
                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.name_user) = $event))
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            (_ctx.errorBayarManual.imageBuktiTF != '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_493, [
                                  _createElementVNode("div", _hoisted_494, _toDisplayString(_ctx.errorBayarManual.imageBuktiTF), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.buttonBayarManualSingle == true &&
                    _ctx.resultBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_495, _hoisted_498))
                        : _createCommentVNode("", true),
                      (_ctx.resultBayarManual == true && _ctx.successBayarManual == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_499, _hoisted_502))
                        : _createCommentVNode("", true),
                      (
                    _ctx.resultBayarManual == true && _ctx.successBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_503, _hoisted_506))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_507, [
                      (
                    _ctx.buttonBayarManualSingle == true &&
                    _ctx.resultBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-danger",
                            style: {"width":"150px"},
                            "data-bs-dismiss": "modal",
                            onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.TutupCancelKonfirmasi()))
                          }, " Tutup "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.tipeBayarManualSingle == true &&
                    _ctx.buttonBayarManualSingle == false &&
                    _ctx.resultBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.clickReset())),
                            style: {"width":"100px"},
                            "data-bs-dismiss": "modal"
                          }, " Batal "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.tipeBayarManualSingle == false &&
                    _ctx.buttonBayarManualSingle == false &&
                    _ctx.resultBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-danger",
                            style: {"width":"100px"},
                            onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.batalFormKonfirmasi()))
                          }, " Batal "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.buttonBayarManualSingle == false &&
                    _ctx.resultBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "btn btn-primary",
                            style: {"width":"150px"},
                            onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.saveModalFormKonfirmasi()))
                          }, " Konfirmasi "))
                        : _createCommentVNode("", true),
                      (
                    _ctx.resultBayarManual == true &&
                    _ctx.successBayarManual == true &&
                    ['SUPER_ADMIN', 'ADMIN_FINANCE'].includes(_ctx.role)
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            class: "btn btn-primary",
                            style: {"width":"150px"},
                            "data-bs-dismiss": "modal",
                            onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.goToPageHistory()))
                          }, " Oke "))
                        : (
                    _ctx.resultBayarManual == true &&
                    _ctx.successBayarManual == true &&
                    ['IMPLEMENTATOR_LEADER', 'IMPLEMENTATOR_MEMBER'].includes(
                      _ctx.role,
                    )
                  )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 5,
                              type: "button",
                              class: "btn btn-primary",
                              style: {"width":"150px"},
                              "data-bs-dismiss": "modal",
                              onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.refreshData()))
                            }, " Oke "))
                          : (
                    _ctx.resultBayarManual == true && _ctx.successBayarManual == true
                  )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 6,
                                type: "button",
                                class: "btn btn-primary",
                                style: {"width":"150px"},
                                "data-bs-dismiss": "modal",
                                onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.clickReset()))
                              }, " Oke "))
                            : _createCommentVNode("", true),
                      (
                    _ctx.resultBayarManual == true && _ctx.successBayarManual == false
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 7,
                            type: "button",
                            class: "btn btn-danger",
                            style: {"width":"150px"},
                            "data-bs-dismiss": "modal",
                            onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.clickReset && _ctx.clickReset(...args)))
                          }, " Tutup "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 512),
              _createElementVNode("div", _hoisted_508, _hoisted_510, 512),
              _createElementVNode("div", _hoisted_511, [
                _createElementVNode("div", _hoisted_512, [
                  _createElementVNode("div", _hoisted_513, [
                    _hoisted_514,
                    _createElementVNode("div", _hoisted_516, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger",
                        style: {"width":"100px"},
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.cancelModalKonfirmasi()))
                      }, " Batal "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.saveModalKonfirmasi()))
                      }, " Konfirmasi ")
                    ])
                  ])
                ])
              ], 512),
              _createElementVNode("div", _hoisted_517, [
                _createElementVNode("div", _hoisted_518, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("select", {
                      name: "kt_customers_table_length",
                      class: "form-select form-select-sm form-select-solid",
                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.paging.size) = $event)),
                      placeholder: "Per page",
                      onChange: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.changePageSize && _ctx.changePageSize(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item,
                          label: `${item}`,
                          value: item
                        }, null, 8, _hoisted_519))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.paging.size]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_520, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
              ]),
              _createElementVNode("div", _hoisted_521, [
                _createElementVNode("ul", _hoisted_522, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      style: {"cursor":"pointer"},
                      onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                    }, " Previous ")
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      style: {"cursor":"pointer"},
                      onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                    }, " Next ")
                  ], 2)
                ])
              ])
            ])
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([_ctx.widgetClasses, "card"])
        }, [
          _hoisted_523,
          _createElementVNode("div", _hoisted_524, [
            _createElementVNode("div", _hoisted_525, [
              _createElementVNode("div", _hoisted_526, [
                _hoisted_527,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "number",
                  class: "form-control form-control-lg",
                  disabled: "",
                  modelValue: _ctx.viewInvoices.number,
                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.viewInvoices.number) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_528, [
                _hoisted_529,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "number",
                  class: "form-control d-flex form-control-lg",
                  disabled: "",
                  modelValue: _ctx.viewInvoices.vaNumber,
                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.viewInvoices.vaNumber) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_530, [
              _createElementVNode("div", _hoisted_531, [
                _hoisted_532,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "invoiceDate",
                  class: "form-control form-control-lg",
                  disabled: "",
                  displayFormat: 'DD.MM.YYYY',
                  modelValue: _ctx.viewInvoices.invoiceDate,
                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.viewInvoices.invoiceDate) = $event))
                }, null, 8, ["displayFormat", "modelValue"])
              ])
            ]),
            _hoisted_533,
            _createElementVNode("div", _hoisted_534, [
              _createElementVNode("div", _hoisted_535, [
                _hoisted_536,
                _createVNode(_component_Field, {
                  name: "schoolName",
                  type: "text",
                  class: "form-control form-control-lg",
                  disabled: "",
                  modelValue: _ctx.viewInvoices.schoolName,
                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.viewInvoices.schoolName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_537, [
                _hoisted_538,
                _createVNode(_component_Field, {
                  name: "expiredDate",
                  type: "text",
                  class: "form-control form-control-lg",
                  disabled: "",
                  modelValue: _ctx.viewInvoices.expiredDate,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.viewInvoices.expiredDate) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_539, [
              _createElementVNode("div", _hoisted_540, [
                _hoisted_541,
                _createVNode(_component_Field, {
                  name: "address",
                  type: "text",
                  class: "form-control form-control-lg",
                  disabled: "",
                  modelValue: _ctx.viewInvoices.address,
                  "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.viewInvoices.address) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_542, [
              _createElementVNode("div", _hoisted_543, [
                _hoisted_544,
                _createVNode(_component_Field, {
                  name: "phone",
                  type: "text",
                  class: "form-control form-control-lg",
                  disabled: "",
                  modelValue: _ctx.viewInvoices.phone,
                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.viewInvoices.phone) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_545, [
              _createElementVNode("div", _hoisted_546, [
                _hoisted_547,
                _createVNode(_component_Field, {
                  name: "phone",
                  type: "text",
                  class: "form-control form-control-lg",
                  disabled: ""
                })
              ])
            ]),
            _hoisted_548,
            _createElementVNode("div", _hoisted_549, [
              _createElementVNode("table", _hoisted_550, [
                _hoisted_551,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewInvoices.detail, (y, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_552, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_553, _toDisplayString(y.name), 1),
                      _createElementVNode("td", _hoisted_554, _toDisplayString(y.qty), 1),
                      _createElementVNode("td", _hoisted_555, "Rp. " + _toDisplayString(_ctx.formatPrice(y.price)), 1),
                      _createElementVNode("td", _hoisted_556, _toDisplayString(y.discount) + " %", 1),
                      _createElementVNode("td", _hoisted_557, _toDisplayString(y.tax) + " %", 1),
                      _hoisted_558,
                      _createElementVNode("td", _hoisted_559, "Rp. " + _toDisplayString(_ctx.formatPrice(y.amount)), 1)
                    ]))
                  }), 128))
                ]),
                _hoisted_560,
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_561, [
                    _hoisted_562,
                    _hoisted_563,
                    _hoisted_564,
                    _hoisted_565,
                    _hoisted_566,
                    _hoisted_567,
                    _hoisted_568,
                    _createElementVNode("th", _hoisted_569, " Rp." + _toDisplayString(_ctx.formatPrice(_ctx.viewInvoices.amount)), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_570,
            _createElementVNode("div", _hoisted_571, [
              _createElementVNode("div", _hoisted_572, [
                _createElementVNode("div", _hoisted_573, [
                  _createElementVNode("div", _hoisted_574, [
                    _hoisted_575,
                    _createVNode(_component_Field, {
                      name: "terbilang",
                      type: "text",
                      class: "form-control form-control-lg",
                      disabled: ""
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_576, [
                  _createElementVNode("div", _hoisted_577, [
                    _hoisted_578,
                    _createElementVNode("div", _hoisted_579, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.viewInvoices.tax)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_580, [
                    _hoisted_581,
                    _createElementVNode("div", _hoisted_582, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.viewInvoices.totalAmount)), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_583, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.goBack()))
              }, "Tutup")
            ])
          ])
        ], 2))
  ], 64))
}